import { IdGraphType, IdsAvailableType } from '@idConnect/types';
import { getAdtechpassValueProxy } from './getAdtechpassValueProxy';

/**
 * Checks if any ID (mtid, atid, or attrid) is available in the first element of the provided idGraphData array.
 *
 * This function evaluates the first object in the array by checking the mtid,
 * the result of processing atid via getAdtechpassValueProxy, and attrid. It returns true if any of these are truthy.
 *
 * @param idGraphData - An array of IdGraphType or IdsAvailableType objects. Only the first element is evaluated.
 * @returns True if at least one of mtid, atid, or attrid is truthy in the first element; otherwise, false.
 */
export const isAnyIdAvailable = (
  idGraphData: Array<IdGraphType> | Array<IdsAvailableType>,
) => {
  if (idGraphData && Array.isArray(idGraphData) && idGraphData.length > 0) {
    const [{ mtid, atid: idGraphAdtechpass, attrid }] = idGraphData;
    const atid = getAdtechpassValueProxy(idGraphAdtechpass);
    return Boolean(mtid || atid || attrid);
  }
  return false;
};
